import { CRM_WEB_PAGES_URLS } from '../../CRM_WEB_PAGES_URLS';
import { OrganizationSettings } from '@care-portals/api-interfaces';

export const ownhealth_ca: OrganizationSettings = {
  name: 'OwnHealth',
  replyToEmail: 'doctor@secure-message.appgen.health',
  ecommerceEnabled: false,
  stripeEnabled: false,
  emrEnabled: true,
  conversationServiceId: '',
  appointmentconsentSection: `
    <p style="text-align: center;color: #536476;">
    By submitting you agree to our&nbsp;
    <a
    href="javascript:window.open('https://ownhealth.ca/privacy-policy', 'popup', 'width=600,height=600');"
    >Privacy&nbsp;Policies</a>
    </p>
    `,

  // navigation
  crmWebAppLayout: {
    title: 'OwnHealth',
    logo: 'https://uploads-ssl.webflow.com/5f788ad8133859911003a61e/5f925eff354687192746cb7f_ownhealth-logo.png',
    mainMenu: [
      {
        title: 'Leads',
        link: CRM_WEB_PAGES_URLS.leads.list,
        icon: 'fa-regular fa-address-book',
        roles: ['*']
      },
      {
        title: 'Appointments',
        link: CRM_WEB_PAGES_URLS.appointments.calendar,
        icon: 'fa-regular fa-calendar-check',
        roles: ['*']
      },
      {
        title: 'Tasks',
        link: CRM_WEB_PAGES_URLS.tasks.list,
        icon: 'fa-solid fa-list-check',
        roles: ['*']
      },
      {
        title: 'Services',
        link: CRM_WEB_PAGES_URLS.services.list,
        icon: 'fas fa-medkit',
        roles: ['admin', 'developer', 'owner']
      },
      {
        title: 'Schedules',
        link: CRM_WEB_PAGES_URLS.schedules.list,
        icon: 'fas fa-calendar',
        roles: ['admin', 'developer', 'owner']
      },
      {
        title: 'Users',
        link: CRM_WEB_PAGES_URLS.users.list,
        icon: 'fas fa-lock',
        roles: ['admin', 'developer', 'owner']
      },
      {
        title: 'Forms',
        link: CRM_WEB_PAGES_URLS.forms.list,
        icon: 'fas fa-table',
        roles: ['admin', 'developer', 'owner']
      },
      {
        title: 'Templates',
        link: CRM_WEB_PAGES_URLS.emailTemplates.list,
        icon: 'fas fa-palette',
        roles: ['admin', 'developer', 'owner']
      },
      {
        title: 'Settings',
        link: CRM_WEB_PAGES_URLS.settings.base,
        icon: 'fa-solid fa-sliders',
        roles: ['admin', 'developer', 'owner']
      }
    ]
  }
};
